import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';

import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';
import { BankArchiveStatus, BankCard } from '../bank.model';

@Component({
	selector: 'app-bank-card-set',
	templateUrl: './bank-card-set.component.html',
	styleUrls: ['./bank-card-set.component.css'],
})
export class BankCardSetComponent {
	@Input() data: BankCard = {
		id: null,
		number: null,
		comments: null,
		status: BankArchiveStatus.ACTIVE,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly router: Router,
	) {}

	submit(): void {
		if (!this.data.id) {
			this.api.post('/bankCards/', this.data, (result, error) => {
				if (error) {
					return;
				}
				this.router.navigate(['bankCards', result.data]);
			});
		} else {
			this.api.put(`/bankCards/${this.data.id}/`, this.data, (result, error) => {
				if (error) {
					return;
				}
				this.infobox.success('Zapisano');
			});
		}
		this.dialogClose();
	}

	dialogOpen(): void {
		new Modal(document.getElementById('addModal')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}
}
